import React from 'react';
import { Container, Box, Typography, Grid } from '@mui/material';
import Hero from '../components/Hero';
import ContactForm from '../components/ContactForm';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import ContactImg from '../assets/images/hero-contact.jpg';
import HeroServicesImg from '../assets/images/hero-services.jpg';

export default function Contact() {
  const m = meta.contact;
  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero title="Contact Rite HVAC Services" subtitle="24/7 emergency hotline: (812) 555-0168" bgImage={ContactImg} />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h2" gutterBottom>Visit or Call</Typography>
            <Typography>123 HVAC Drive, Bloomington, IN 47401</Typography>
            <Typography>Phone: +1 (812) 555-0168</Typography>
            <Typography>Email: info@ritehvacservices.com</Typography>
            <Typography sx={{ mt: 2 }}>Hours: 24/7 Emergency Service</Typography>
            <Box component="img" src={HeroServicesImg} alt="Map placeholder" sx={{ width:'100%', mt: 2, borderRadius: 2, border:'1px solid #eee' }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h2" gutterBottom>Send a Message</Typography>
            <ContactForm />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
